import axios from "axios";

export async function downloadPdf(url, fallbackFilename) {
  const res = await axios.get(url, { responseType: "blob" });
  const disposition = res.headers["content-disposition"];
  let filename = fallbackFilename;
  if (disposition && disposition.indexOf("filename=") !== -1) {
    const matches = disposition.match(/filename="?([^"]+)"?/);
    if (matches != null && matches[1]) {
      filename = matches[1];
    }
  }

  const file = new Blob([res.data], { type: "application/pdf" });
  const fileURL = URL.createObjectURL(file);
  const link = document.createElement("a");
  link.href = fileURL;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
}
